import { DataGrid } from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useState } from 'react';

const DataGridTable = ({rows, columns, getRowId, onRowClick, renderers = {} }) => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 5 });

  const enhancedColumns = columns.map(col => ({
    ...col,
    renderCell: renderers[col.field] ?? col.renderCell,
  }));

  return (
    <Stack spacing={2} sx={{ width: '100%', minWidth: 0, overflow: 'hidden' }}>
      <Box sx={{ height: 400, width: '100%', minWidth: 0, overflow: 'hidden' }}>
        <DataGrid
          rows={rows}
          columns={enhancedColumns}
          getRowId={getRowId}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          sx={{
            border: 0,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#243b5a',
              color: '#ffffff',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
            },
            '& .MuiDataGrid-main': {
              minWidth: 0,
            },
            '& .MuiDataGrid-footerContainer': {
              flexWrap: 'nowrap',
              minHeight: 52,
            },
            '& .MuiTablePagination-root': {
              overflow: 'hidden',
            },
          }}
          onRowClick={onRowClick}
        />
      </Box>
    </Stack>
  );
};

export default DataGridTable;
